import React, { useContext } from 'react';
import AdhesionAdUnit from '../AdUnit/Adhesion/Adhesion';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const DevpageAdhesionPlacement = ()=>{
    const isDealerAdhesion = useFlag('dealer_json_adhesion');
    const { isLoggedIn } = useContext(SessionContext);
    const isMobile = useContext(MobileContext);
    if (isLoggedIn || isMobile || !isDealerAdhesion) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(AdhesionAdUnit, {
        realEstateId: "8ee4d437-0bec-440e-ab1e-092e0c5cbedc"
    });
};
DevpageAdhesionPlacement.displayName = 'DevpageAdhesionPlacement';
export default DevpageAdhesionPlacement;
